import { Input, Empty } from 'antd'
import { FC, useState, useMemo } from 'react'

interface SearchInputProps<T> {
	data: T[]
	onSearch: (filteredData: T[]) => void
	searchFields: (keyof T)[]
	placeholder?: string
	children?: (filteredData: T[]) => React.ReactNode
}

export const SearchInput: FC<SearchInputProps<any>> = ({
	data,
	onSearch,
	searchFields,
	placeholder = 'Поиск',
	children
}) => {
	const [searchValue, setSearchValue] = useState('')

	const filteredData = useMemo(() => {
		if (!searchValue.trim()) {
			return data
		}

		const lowerSearch = searchValue.toLowerCase()
		return data.filter((item) =>
			searchFields.some((field) => {
				const value = item[field]
				if (value === null || value === undefined) {
					return false
				}
				return String(value).toLowerCase().includes(lowerSearch)
			})
		)
	}, [data, searchValue, searchFields])

	const handleSearch = (value: string) => {
		setSearchValue(value)
		onSearch(filteredData)
	}

	return (
		<div>
			<Input.Search
				placeholder={placeholder}
				value={searchValue}
				onChange={(e) => handleSearch(e.target.value)}
				style={{ marginBottom: '16px' }}
			/>
			{children ? (
				children(filteredData)
			) : filteredData.length === 0 ? (
				<Empty description="Данные не найдены" />
			) : null}
		</div>
	)
}
